module.exports = __webpack_public_path__ + "media/images/version_merge/american_express_logo-1103d916245a09dfa21e311eec3fe74a.png";